import React from "react";
import Header from "../../../components/Header/Header";
import {Container} from "reactstrap";
import {lang, language} from "../../../const/language";
import ViewCourses from "../../../components/viewCourses/viewCourses";
import NotFound from "../../../components/NotFound/NotFound";
import Paginate from "../../../components/Paginate/Paginate";
import CardsFooter from "../../../components/Modals/Footers/CardsFooter";
import ViewPurchasedCourses from "./ViewPurchasedCourses";
import Row from "react-bootstrap/Row";
import ViberHeader from "../../../components/header-new/ViberHeader";


class MyCourses extends React.Component{

    componentDidMount() {
        console.log(this.props);
    }

    render() {
        return(
            <div>
                {/*<Header active={5}/>*/}
                <ViberHeader/>
                <main ref="main" className={"my-class"}>
                    <section>
                        <Container>

                            <div>
                                <h3 className={"teach-black-text head-topic align-center"}>{language[lang].ListOfJoinedCourses}</h3>
                            </div>
                            <Row>
                                <ViewPurchasedCourses history={this.props.history} userType={this.props.location.state}/>
                            </Row>
                            {/*<Paginate className={`m-15-paginate`} handlePageClick={this.handlePageClick}  pageCount={pagination.pageCount} initialPage={pagination.page} disableInitialCallback={true}/>*/}
                        </Container>
                    </section>
                </main>
                <CardsFooter/>
            </div>
        )
    }
}
export default MyCourses;